import { patientActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import _ from 'lodash';

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadFotoEpisodesSuccess]: (state, action) => {
        return { ...state, ...action.payload.entities.fotoEpisodes };
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        if (action.payload.fotoEpisodes.entities) {
            return { ...state, ...action.payload.fotoEpisodes.entities.fotoEpisodes };
        } else {
            return state;
        }
    },
    [patientActions.refreshFotoEpisodesSuccess]: (state, action) => {
        Object.values(state).forEach(x => {
            if (x.epno === action.payload.epno) {
                delete state[x.id];
            }
        })
        return { ...action.payload.fotoRefresh.entities.fotoEpisodes };
    },
    [patientActions.refreshFotoResponseSuccess]: (state, action) => {
        return { ...state, ...action.payload.entities.PTOUTMEASURES }
    },
    [patientActions.refreshFotoMessuresResponseSuccess]: (state, action) => {
        return { ...state, ...action.payload.fotoRefresh.entities.FOTOPATIENTRESPONSE }
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.PTNO === action.payload) {
                delete state[x.fotoEpisodeId];
            }
        })
    },
    [patientActions.changeFotoClaimStatusSuccess]: (state, action) => {
        return _.merge(state, action.payload.response.entities.fotoEpisodes);
    }

})


